import { Box, Button, Center, Flex, FormLabel, Input, Text, Textarea, Spinner, Image,
List, ListItem, Checkbox, Grid, FormControl, Heading, Select, Fade, Divider, ListIcon,
EditablePreview, useColorModeValue, IconButton, useDisclosure, useEditableControls, 
ButtonGroup, SlideFade, Editable, Tooltip, EditableInput, EditableTextarea, Accordion,
AccordionItem, AccordionButton, AccordionIcon, AccordionPanel, Spacer} from '@chakra-ui/react'
import { useState, useRef, useEffect } from 'react'
import copy from 'copy-to-clipboard';
import "@fontsource/barlow-condensed"
import Chatdots from './Chatdots';
import {MinusIcon, AddIcon, CheckIcon, CloseIcon, 
   CopyIcon, EditIcon, RepeatIcon, ArrowBackIcon, ChevronRightIcon} from '@chakra-ui/icons'
import printIcon from "../assets/print_icon.png";
import shareIcon from "../assets/share_icon.png";
import downloadIcon from "../assets/download_icon.png";
import EmailModal from "./EmailModal.js"
import {ReactComponent as Thumbsup} from '../assets/thumbsup1.svg'
import {ReactComponent as Thumbsdown} from '../assets/thumbsdown1.svg'

const JobHolder= ({ title, label , valueOfText, companyName }) => {
  const textareaRef = useRef();

  function handleCopy() {
    // jobDescription
    if (textareaRef.current) {
      copy(textareaRef.current.value);
    }
  }



  return (
    <>
    { valueOfText.trim() === ""? (null) : (
    <Fade in={true} transition={{ enter: { duration: 0.35 } }}>
    <Box style={{ position: "relative", marginTop: "20px" }} minW={"80vw"} >
    <Button color={"black"} position={"absolute"} top={"-5"} right={"0"} onClick={handleCopy}>Copy</Button>
    <Text marginBottom={"10px"} color={"white"} textAlign={["left","center"]} htmlFor="textarea">{label}</Text>
    <Textarea bg={"rgba(255,255,255,0.1)"}color={"white"} height={["400px"]} ref={textareaRef} readOnly border={"1px"} id="textarea" value={companyName + " - " + title + "\n\n" +valueOfText}  />
  </Box>
  </Fade>


    )

    }
    </>
  );
};


// const JobDescription = ({descriptionObject}) => {
//   return (
//     <Box color="white">
//       {Object.keys(descriptionObject).map((key) => {
//         return (
//           <Box key={key}>
//             <Heading as="h3" size="lg">{key}</Heading>
//             {typeof descriptionObject[key] === 'string' ? <Text>{descriptionObject[key]}</Text> : 
//               Object.keys(descriptionObject[key]).map((subKey) => {
//                 return (
//                   <Box key={subKey}>
//                     <Heading as="h4" size="md">{subKey}</Heading>
//                     <Text>{descriptionObject[key][subKey]}</Text>
//                   </Box>
//                 )
//               })
//             }
//           </Box>
//         )
//       })}
//     </Box>
//   );
// }

const JobDescriptionPage = ({experienceJobDescription, descriptionObject, jobDescription , formatedJobPost}) => {

  function handleCopy() {
    // jobDescription
    console.log(jobDescription)
      copy(formatedJobPost);
    
  }

  return (
    <Box position={"relative"} width={"100%"} color="white">
          <Divider marginBottom={"50px"}></Divider>
          <Heading marginBottom={"30px"} textAlign={"left"} as="h3" size="lg">Job Summary</Heading>
     <Flex  width={"100%"} justifyContent="center" marginBottom={["50px","50px"]} alignItems={["center","center","auto"]} paddingLeft={["0px","30px"]} color="white" flexDir={["column","column","row"]}>
        <Spacer></Spacer>
        <Text fontSize={"20px"} textAlign={["center","center","left"]} >{descriptionObject["Job Summary and Responsibilities"]}</Text>
      </Flex>
      <Divider opacity={"50%"} marginBottom="50px"></Divider>
      
      {Object.keys(descriptionObject).map((key) => {
        return (
          <>
          { key === "Job Summary and Responsibilities" ? (null) :(
          <Box key={key}>
          
            <Heading marginBottom={"30px"} textAlign={"left"} as="h3" size="lg">{key}</Heading>
            {typeof descriptionObject[key] === 'string' ? 
            (<Text>{descriptionObject[key]}</Text>) : 
              Object.keys(descriptionObject[key]).map((subKey) => {
                return (
                  <Flex key={subKey} marginBottom={["50px","50px"]} alignItems={["center","center","auto"]} paddingLeft={["0px","30px"]} color="white" flexDir={["column","column","row"]}>
                    <Heading paddingTop={"40px"} width={"300px"} textAlign={"left"} as="h4" size="md">{subKey}</Heading>
                    <List width={["100%","80%"]}>
                      {descriptionObject[key][subKey].map((item) => (
                        <Center>
                        <ListItem fontSize={"20px"}  textAlign={"left"} width={"75%"} key={item}>
                        <ListIcon boxSize={5} opacity={"50%"} as={MinusIcon} color='white' />
                        {item}
                        </ListItem>
                        </Center>
                      ))}
                    </List>
                    </Flex>
                )
              })
            }
          </Box>
        )}
          </>
        )
      })}
      { <>
        <Heading marginBottom={"30px"} textAlign={"left"} as="h3" size="lg">Experience & Qualifications</Heading>
        <Flex marginBottom={["50px","50px"]} alignItems={["center","center","auto"]} paddingLeft={["0px","30px"]} color="white" flexDir={["column","column","row"]}>
        <Spacer></Spacer>
        <List width={["100%","80%"]}>
        <>
        {
        experienceJobDescription.map((item)=>{
          return (
            <Center>
            <ListItem fontSize={"20px"}  textAlign={"left"} width={"75%"} key={item}>
            <ListIcon boxSize={5} opacity={"50%"} as={MinusIcon} color='white' />
            {item}
            </ListItem>
            </Center>
            
          )
        })
        }
        </>
        </List>
        </Flex>
        </>
      }
    </Box>
  );
}


function CompetencyList({ fieldKey, heading, structuredSkills, handleCheck, handleAddSkillSpecific }) {
  // TODO potentially combine two of the lists into one
  const [jobToAdd, setJobToAdd] = useState("")


  return (
    <Flex marginBottom={["100px","100px"]} alignItems={["auto","auto","center"]} paddingLeft={["0px","30px"]} color="white" flexDir={["column","column","row"]}>
      <Center>
      <Heading opacity={"50%"} width={["200px"]} fontSize={"15px"} as="h2" size="md">{heading}
      </Heading>
      </Center>
      <List width={["90%","90%","600px","1000px"]} textAlign={"left"}>
      <ListItem>
      <Flex margin={["30px"]} flexDirection="row" > 
      <AddIcon onClick={() => {handleAddSkillSpecific(fieldKey, jobToAdd)
      setJobToAdd("")}}
      marginRight={"10px"} rounded={"full"} padding={"10px"} background={"white"} color={"black"} boxSize={10} />
      <Input 
      _placeholder={{color: "whiteAlpha.800"}}
      background={"whiteAlpha.200"}
      value={jobToAdd}
      onChange={event => setJobToAdd(event.target.value)}
        onKeyPress={(e) => {
        if (e.key === 'Enter') {
              handleAddSkillSpecific(fieldKey, jobToAdd)
              console.log(fieldKey)
              setJobToAdd("")
        }
        }}
       placeholder={[`Add additional skills`]}></Input>
       </Flex>
      </ListItem>
        {structuredSkills.map((item, index) => {
          return (
            <ListItem _hover={{cursor: "pointer"}} key={item.value} onClick={e => handleCheck(fieldKey, index)}>
                <Checkbox fontSize={["15px","20px","25px"]}
                margin={["30px"]}
variant={"circular"} size="xxl"
                  isChecked={item.selected}
                  onChange={e => handleCheck(fieldKey, index)}
                >
                  {item.value}
                </Checkbox>
                <Center opacity={"50%"} color={"gray.100"}>
                <Divider marginRight={"0px"}></Divider>
                </Center>
            </ListItem>
            
          );
        })}
      </List>
    </Flex>
  );
}

function EditableBox({item ="item", setItem = ()=> console.log("hi"), width="50%", fontSize="20px",
notSetPlaceholder="Not Set", fontStyle="", color="", placeholder="", waiting
}) {
  /* Here's a custom control */
  function EditableControls() {
    const {
      isEditing,
      getSubmitButtonProps,
      getCancelButtonProps,
      getEditButtonProps
    } = useEditableControls();
    return (
      <>
      
      {isEditing ? (
      <ButtonGroup opacity={"100%"} fontSize={fontSize} >
        <IconButton icon={<CheckIcon color={"black"} />} {...getSubmitButtonProps()} />
        {/* <IconButton
          icon={<CloseIcon color={"black"} boxSize={3} />}
          {...getCancelButtonProps()}
        /> */}
      </ButtonGroup>
    ) :
    <IconButton  size='sm' color={"black"} icon={<EditIcon />} {...getEditButtonProps()} />
      }

      </>)
  }

  return (
      <Editable
      isDisabled={waiting}
      fontSize={fontSize}
      textAlign={["center","center","left","left",]}
      fontStyle={fontStyle}
      width={width}
      color={color}
      placeholder={placeholder}
        defaultValue={item.trim() === "" ? placeholder : item}
        isPreviewFocusable={true}
        selectAllOnFocus={false}
        _hover = {{backgroundColor : "whiteAlpha.100"}}
      >
      <Flex justifyContent={"space-between"}>
      <EditableControls />
        <Tooltip label="Click to edit">
          <EditablePreview 
           width={"100%"}
            py={2}
            px={4}
            _hover={{
              background: "whiteAlpha.100"
            }}
          />
        </Tooltip>
        <Input width={"100%"}
        fontSize={fontSize}
        onChange={event => setItem(event.target.value)}
        py={2} px={4} padding={fontSize} as={EditableInput} />
        </Flex>
      </Editable>
  );
}

const FinalEditBox = ({title, setTitle, submitJob , waiting, setWaiting,
  description, setDescription, companyName ,setCompanyName ,companyUrl, 
  setCompanyUrl, handleSelectedSkills,
  setDisplayGeneration, setShowInput, setSkillsStage, handleCopy }) =>{

    
  return(
    <>
<Flex color={"gray.200"}>
    <Flex width={"100%"} marginTop={["5px","30px"]} flexDir={"column"}>
  <Flex justifyContent={"space-between"} flexDir={["column","column","row"]}>
        {/* <FormLabel width={"150px"} htmlFor="title">Job Title</FormLabel> */}
  <Accordion width={"100%"} allowToggle>
  <AccordionItem >
    <h2>
      <AccordionButton>
        <Box  >
         <Text fontSize={"30px"} >View Original Input</Text>
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4}>
    <Fade in={true} transition={{ enter: { duration: 0.35 } }}>
  <Box  >
  {/* <Text  fontSize={"25px"} marginTop={"20px"} textAlign={"center"}>Type or copy/paste some text. The more descriptive, the better</Text> */}
  <Center color={"gray.200"}>
  <br></br>
  <Flex marginTop={["5px","30px"]} maxW={"80%"} flexDir={"column"}>
    <Flex margin={["10px","20px"]} flexDir={["column","column","row"]}>
      <FormLabel width={"100px"}>Title</FormLabel>
      <Text width={["70vw","60vw"]}>{title}</Text>
    </Flex>
    <Flex margin={["10px","20px"]} flexDir={["column","column","row"]}>
      {/* <FormLabel width={"150px"} htmlFor="title">Job Title</FormLabel> */}
      <FormLabel width={"100px"}>Description</FormLabel>
      <Text>{description}</Text>

    </Flex>
    <Flex margin={["10px","20px"]} flexDir={["column","column","row"]}>
      <FormLabel width={["200px","100px"]}>Company Name</FormLabel>
      <Text>{companyName}</Text>
    </Flex>
    <Center >
    <Box position={"relative"}>
</Box>
</Center>
    </Flex>
  </Center>
      </Box>
      </Fade>
    </AccordionPanel>
  </AccordionItem>
</Accordion>
        <Flex justifyContent={"right"} flexDir={["row","row","column","column"]}>
        {/* <Button color="white" background={"whiteAlpha.500"} disabled={waiting} margin={"10px"}
        width={["200px"]}
              onClick={() => {handleSelectedSkills() 
          }}>{waiting ? (
          <Chatdots color=""></Chatdots>
          ):(<><RepeatIcon marginRight={"25px"} boxSize={6} />{"Regenerate"}</>)}
      </Button> */}
      {/* <Text marginBottom={"30px"} onClick={()=>{
        setSkillsStage(true)
          setShowInput(false)
      }} cursor={"pointer"} fontWeight={"bold"} color={"#FBBF24"}>
      {<ArrowBackIcon marginBottom={"2px"}></ArrowBackIcon>}{"Skill Select"}</Text> */}
      </Flex>
      </Flex>
      <Text textDecor={"underline"} marginTop={"10px"} textAlign={"right"} onClick={() => {
        setDisplayGeneration(true) 
          setShowInput(false)}} cursor={"pointer"} fontWeight={"bold"} color={"#FBBF24"}>
          {<ArrowBackIcon marginBottom={"2px"}></ArrowBackIcon>}{"Start Over"}</Text>

      <Flex  margin={["20px 0px","20px 0px"]} flexDir={["column","column","column"]}>
      <Flex   flexDir={["column","column","column"]}>
        <Flex justifyContent={"space-between"} textAlign={"left"} margin={"20px 0px"} flexDir={["column-reverse","column-reverse","row","row" ]}>
          <EditableBox waiting={waiting} width={["100%","100%","50%","50%"]} fontSize={["30px","35px","55px"]} item={title} setItem={setTitle}></EditableBox>
          <Box marginBottom={["40px","20px","0px","0px",]} marginRight={["0px","0px","20px","20px"]}>
          <Button margin="5px" color="white" background={"whiteAlpha.500"} onClick={handleCopy}><CopyIcon margin={"10px"}/>Copy All</Button>
          <Button margin="5px" color="white" background={"whiteAlpha.500"} ><Image height={"30px"} src={printIcon}></Image></Button>
          <Button margin="5px" color="white" background={"whiteAlpha.500"} ><Image height={"30px"} src={shareIcon}></Image></Button>
          <Button margin="5px" color="white" background={"whiteAlpha.500"} ><Image height={"30px"} src={downloadIcon}></Image></Button>
          </Box>
        </Flex>
        <Flex flexDir={["column","column","row", "row"]} textAlign={"left"} margin={"20px 0px"}>
          <EditableBox waiting={waiting} width={["100%","100%","50%","50%"]} fontSize={["25px","30px","45px"]} placeholder="Sample Company Name" color='whiteAlpha.400' fontStyle={"italic"} item={companyName} setItem={setCompanyName}></EditableBox>
          <EditableBox waiting={waiting} width={["100%","100%","40%","40%"]}fontSize={["20px","20px","25px"]} placeholder="www.samplejobposting.com" item={companyUrl} setItem={setCompanyUrl}></EditableBox>
        </Flex>
      </Flex>
      <Box textAlign={"left"} margin={"20px 0px"}>
      
      </Box>

      </Flex>

  <Center>
</Center>

    </Flex>
  </Flex>
  </>

  )
}


export default function AbstractGen({url}) {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [companyUrl, setCompanyUrl] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [jobToSubmit, setJobToSubmit] = useState('')
  const [displayGeneration, setDisplayGeneration] = useState(true)
  const [jobDescription, setJobDescription] = useState("")
  const [waiting, setWaiting] = useState(false)
  const [skills, setSkills] = useState([]);
  const [skillsStage, setSkillsStage] = useState(true);
  const [newSkill, setNewSkill] = useState('');
  const [showInput, setShowInput] = useState(false);
  const [currentAddSelect, setCurrentAddSelect] = useState("required_occupational_competencies")
  const [structuredSkills, setStructuredSkills] = useState( {
    "required_occupational_competencies": [
    ],
    "preferred_occupational_competencies": [
    ],
    "required_foundational_competencies": [
    ],
    "preferred_foundational_competencies": [
    ]
  })
  const [descriptionObject, setDescriptionObject] = useState({})
  const [experienceJobDescription, setExperienceJobDescription] = useState("")
  const [finalStage, setFinalStage] = useState(true)
  const [formatedJobPost, setFormatedJobPost] = useState("")
  const [emailModal, setEmailModal] = useState(false)
  const [emailInput, setEmailInput] = useState("")
  const [thumbsFeedback, setThumbsFeedback] = useState(false)
  const [thumbsDownColor, setThumbsDownColor] = useState("white")
  const [thumbsUpColor, setThumbsUpColor] = useState("white")
  const [thumbsDownBackColor, setThumbsDownBackColor] = useState("")
  const [thumbsUpBackColor, setThumbsUpBackColor] = useState("")
  const [feedback, setFeedback] = useState("")
  const [submittedFeedback, setSubmittedFeedback] = useState(false)
  const [thumbs, setThumbs] = useState(false)


  useEffect(()=>{
    console.log("jobToSubmit", jobToSubmit)
  
  },[jobToSubmit])

  useEffect(() => {
    // TODO have individula devmodes only
    setFeedback("")
    setThumbsFeedback(false)
    setSubmittedFeedback(false)
    setThumbsDownColor("white")
    setThumbsUpColor("white")
    setThumbsDownBackColor("")
    setThumbsUpBackColor("")
}, [skillsStage,displayGeneration,waiting])  

  useEffect(()=>{
    console.log("skills", skills)
    console.log("title", title)
    console.log("description", description)
    let finalCopy = title  + "\n\n" + companyName + "\n\n" + companyUrl + "\n\n" +  jobDescription
    setFormatedJobPost(finalCopy)
    console.log(experienceJobDescription)
  },[skills , title , description, jobDescription, companyName, companyUrl, experienceJobDescription])
  

  function handleCopy() {
    // jobDescription
    console.log(jobDescription)
      copy(formatedJobPost);
    
  }

// original 

  // const submitJob = async () =>{
  //   setWaiting(true)
  //   let dataToSend = { 
  //                   // generation info
                    
  //                     // message : jobToSubmit,
  //                     generationInfo :{
  //                       description: description,
  //                       title: title,
  //                       companyName: companyName,
  //                     },
         
  //               }
  //   try {
  //     console.log(dataToSend)
  //       const response = await fetch(`${url}/submitjobplus`, {
  //       method: 'POST',
  //       body: JSON.stringify(dataToSend),
  //       headers: {
  //           'Content-Type': 'application/json'
  //       }
  //       })
  //       const data = await response.json()
  //       console.log(data)
  //       setJobDescription(data.message)
  //       setDisplayGeneration(false)
  //       } catch (error) {
  //           console.error(error)
  //       }
  //       setWaiting(false)
  //   }
  
     
//   const submitJob = async () =>{
//     setWaiting(true)
//     let dataToSend = { 
//                     // generation info
                    
//                       // message : jobToSubmit,
//                       generationInfo :{
//                         description: description,
//                         title: title,
//                         companyName: companyName,
//                       },
         
//                 }
// try {
//   console.log(dataToSend)
//     const response = await fetch(`${url}/submitjobtitle`, {
//     method: 'POST',
//     body: JSON.stringify(dataToSend),
//     headers: {
//         'Content-Type': 'application/json'
//     }
//     })
//     const data = await response.json()
//     console.log(data)
//     let skills_object = data.skills_object
//     const sortedSkills = Object.entries(skills_object).sort((a, b) => parseInt(a[0]) - parseInt(b[0]))
//     .map(([key, value]) => ({ key: parseInt(key), value, selected: true }));
//     setSkills(sortedSkills);
//     console.log("sortedSkills: ", sortedSkills)
//     setJobDescription(data.message)
//     setSkillsStage(true)
//     setDisplayGeneration(false)
//     } catch (error) {
//         console.error(error)
//     }
//     setWaiting(false)
// }

const emailSubmit = async () =>{
  console.log("calling email submit")
  let dataToSend = { 
                  // generation info
                  
                    // message : jobToSubmit,
                    generationInfo :{
                      description: description,
                      title: title,
                      companyName: companyName,
                      posting: formatedJobPost,
                    },
                    email: emailInput,
                    skills: structuredSkills
       
              }
try {
console.log(dataToSend)
  const response = await fetch(`${url}/emailsubmit`, {
  method: 'POST',
  body: JSON.stringify(dataToSend),
  headers: {
      'Content-Type': 'application/json'
  }
  })
  const data = await response.json()
  console.log(data)


  } catch (error) {
      console.error(error)
  }

}

const feedbackSubmit = async () =>{
  console.log("calling feedbackSubmit")
  setSubmittedFeedback(true)
  let dataToSend = { 
                  // generation info
                  
                    // message : jobToSubmit,
                    generationInfo :{
                      description: description,
                      title: title,
                      companyName: companyName,
                      posting: formatedJobPost,
                    },
                    email: emailInput,
                    skills: structuredSkills,
                    feedback: feedback,
                    thumbs: thumbs
       
              }
try {
console.log(dataToSend)
  const response = await fetch(`${url}/feedback`, {
  method: 'POST',
  body: JSON.stringify(dataToSend),
  headers: {
      'Content-Type': 'application/json'
  }
  })
  const data = await response.json()
  console.log(data)


  } catch (error) {
      console.error(error)
  }

}



const submitThumbs = async (thumbs)  =>{
  console.log("calling thumbs submit")
  if (thumbs === false){
    setThumbsFeedback(true)
    setThumbsDownColor("#E53E3E")
    setThumbsDownBackColor("white")
    setThumbsUpBackColor("")
    setThumbsUpColor("grey")
  }
  if (thumbs === true){
    setThumbsFeedback(true)
    setThumbsUpColor("#38A169")
    setThumbsUpBackColor("white")
    setThumbsDownBackColor("")
    setThumbsDownColor("grey")
  }
  let dataToSend = { 
                  // generation info
                  
                    // message : jobToSubmit,
                    generationInfo :{
                      description: description,
                      title: title,
                      companyName: companyName,
                      posting: formatedJobPost,
                    },
                    email: emailInput,
                    skills: structuredSkills,
                    thumbs: thumbs
       
              }
try {
console.log(dataToSend)
  const response = await fetch(`${url}/thumbs`, {
  method: 'POST',
  body: JSON.stringify(dataToSend),
  headers: {
      'Content-Type': 'application/json'
  }
  })
  const data = await response.json()
  console.log(data)


  } catch (error) {
      console.error(error)
  }

}

  
const submitJob = async () =>{
  setWaiting(true)
  let dataToSend = { 
                  // generation info
                  
                    // message : jobToSubmit,
                    generationInfo :{
                      description: description,
                      title: title,
                      companyName: companyName,
                    },
       
              }
try {
console.log(dataToSend)
  const response = await fetch(`${url}/submitjobtitle`, {
  method: 'POST',
  body: JSON.stringify(dataToSend),
  headers: {
      'Content-Type': 'application/json'
  }
  })
  const data = await response.json()
  console.log(data)
  let skills_object = data.skills_object
  console.log("skills_object",skills_object)


  let updated_skills = {}

  Object.keys(skills_object).forEach(key => {
    const newArr = skills_object[key].map(item => {
      return {
        selected: true,
        value: item
      };
    });
    updated_skills[key] = newArr;
  });

  setStructuredSkills(updated_skills)


  setSkillsStage(true)
  setDisplayGeneration(false)
  } catch (error) {
      console.error(error)
  }
  setWaiting(false)
  window.scrollTo(0, 0)
}


// const submitSkills = async (skillsToUse) =>{
//   setWaiting(true)
//   let dataToSend = { 
//                   // generation info
//                   generationInfo : {
//                     description: description,
//                     title: title,
//                     companyName: companyName,
//                   },
//                     skills: skillsToUse
//               }
//     try {
//     console.log(dataToSend)
//       const response = await fetch(`${url}/submitfinalskills`, {
//       method: 'POST',
//       body: JSON.stringify(dataToSend),
//       headers: {
//           'Content-Type': 'application/json'
//       }
//       })
//       const data = await response.json()
//       console.log(data)
//       setJobDescription(data.message)
//       setDisplayGeneration(false)
//       setSkillsStage(false)
//       } catch (error) {
//           console.error(error)
//       }
//       setWaiting(false)
// }



const submitSkills = async () =>{
  setWaiting(true)
  let dataToSend = { 
                  // generation info
                  generationInfo : {
                    description: description,
                    title: title,
                    companyName: companyName,
                  },
                    skills: structuredSkills
              }
    try {
    console.log(dataToSend)
      const response = await fetch(`${url}/submitfinalskills`, {
      method: 'POST',
      body: JSON.stringify(dataToSend),
      headers: {
          'Content-Type': 'application/json'
      }
      })
      const data = await response.json()
      console.log(data)
      setJobDescription(data.message)
      setDescriptionObject(data.parse_result)
      setExperienceJobDescription(data.experience_necessary_parse)
      setDisplayGeneration(false)
      setSkillsStage(false)
      } catch (error) {
          console.error(error)
      }
      setWaiting(false)
      window.scrollTo(0, 0)
      setEmailModal(true)
}


const handleSelectedSkills = () =>{
  console.log("calling handleSelectedSkills")
  // let skillsToUse = getSelectedSkills()
  // console.log(skillsToUse)
  submitSkills()
}

const getSelectedSkills = () => {
  return skills.filter(skill => skill.selected);
}

// const handleCheck = (key) => {
//   setSkills(skills.map(skill => skill.key === key ? {...skill, selected: !skill.selected} : skill))
// }

const handleCheck = (competencyType, index) => {
  console.log("structuredSkills", structuredSkills)
  
  const updatedStructuredSkills = {...structuredSkills};
  console.log("thing", updatedStructuredSkills[competencyType])
  updatedStructuredSkills[competencyType][index].selected = !updatedStructuredSkills[competencyType][index].selected;
  setStructuredSkills(updatedStructuredSkills);
}


// const handleAddSkill = () => {
//   const nextKey =  skills.length + 1;
//   setSkills([ { key: nextKey, value: newSkill, selected: true }, ...skills]);
//   setNewSkill('');
// }


const handleAddSkill = (event) => {
  // let field_to_add_to = "required_occupational_competencies"
  // if (competency !== null){
  //   console.log("competency",competency)
  //   field_to_add_to = competency
  // }
  console.log("event",event)
  let competencyField = currentAddSelect

  console.log("currentAddSelect.key", currentAddSelect)
  
  const updatedStructuredSkills = {...structuredSkills};

  updatedStructuredSkills[currentAddSelect].push({value: newSkill, key: newSkill, selected: true})
  setStructuredSkills(updatedStructuredSkills);

  setNewSkill('');
}

const handleAddSkillSpecific = (competencyField, newSkill) => {
  // let field_to_add_to = "required_occupational_competencies"
  // if (competency !== null){
  //   console.log("competency",competency)
  //   field_to_add_to = competency
  // }
  if (newSkill === "") {
    return
  }
  console.log("currentAddSelect.key", currentAddSelect)
  
  const updatedStructuredSkills = {...structuredSkills};

  updatedStructuredSkills[competencyField].unshift({value: newSkill, key: newSkill, selected: true})
  setStructuredSkills(updatedStructuredSkills);

  setNewSkill('');
}

  return (
    <>
    
  <Box>

  <Flex justifyContent={"center"}>
  <EmailModal emailModal={emailModal} setEmailModal={setEmailModal}   
  setEmailInput={setEmailInput} emailInput={emailInput} emailSubmit={emailSubmit}></EmailModal>
  {!displayGeneration ? ( <><Button variant={"ghost"}
  onClick={() => {setSkillsStage(true)
          setCurrentAddSelect("required_occupational_competencies")
          setDisplayGeneration(true)}}
        _hover = {{bg: "whiteAlpha.100"}}
  > Input </Button> </>) : (null)}
  {!displayGeneration ? ( <><ChevronRightIcon marginTop={"13px"}/><Button variant={"ghost"}
  onClick={() => {setSkillsStage(true)
          setCurrentAddSelect("required_occupational_competencies")
          setShowInput(false)}}
        _hover = {{bg: "whiteAlpha.100"}}
  > Skill Select </Button> </>) : (null)}
  {!skillsStage && !displayGeneration ? ( <><ChevronRightIcon marginTop={"13px"}/><Button variant={"ghost"}
  _hover = {{bg: "whiteAlpha.100"}}
  > Finish & Share </Button> </>) : (null)}
  </Flex>
    
  </Box>
    {displayGeneration ? (
      <>
  <Fade in={true} transition={{ enter: { duration: 0.35 } }}>
  <Box minH={"70vh"} >
  <Text fontWeight={"extrabold"}  fontSize={["25px","50px"]} marginTop={"10px"} textAlign={"center"}>Job Post Generator</Text>
  {/* <Text  fontSize={"25px"} marginTop={"20px"} textAlign={"center"}>Type or copy/paste some text. The more descriptive, the better</Text> */}
  <Center color={"gray.200"}>
  <br></br>
  <Flex marginTop={["5px","30px"]} maxW={"80%"} flexDir={"column"}>
    <Flex margin={["10px","20px"]} flexDir={["column","column","row"]}>
      <FormLabel width={"100px"}>Title</FormLabel>
      <Input 
            borderColor={["#FBBF24"]}
          bgColor={"#63708e"}
          _hover={{borderColor : "#FEF3C7"}}
          _active={{borderColor : "#FEF3C7"}}
          _focus={{borderColor : "#FEF3C7"}}
          _placeholder={{ opacity: 0.5, color: 'white' }} width={["70vw","60vw"]}
          type={"text"} placeholder="What is this job called?"
                value={title} onChange={event => setTitle(event.target.value)}
                onKeyPress={(e) => {
        if (e.key === 'Enter') {
            if (!waiting){
              submitJob()
            }
        }
        }}
                >
      </Input>
    </Flex>
    <Flex margin={["10px","20px"]} flexDir={["column","column","row"]}>
      {/* <FormLabel width={"150px"} htmlFor="title">Job Title</FormLabel> */}
      <FormLabel width={"100px"}>Description</FormLabel>
      <Textarea 
      borderColor={["#FBBF24"]}
      bgColor={"#63708e"}
      _hover={{borderColor : "#FEF3C7"}}
      _active={{borderColor : "#FEF3C7"}}
      _focus={{borderColor : "#FEF3C7"}}
      _placeholder={{ opacity: 0.5, color: 'white' }} width={["70vw","60vw"]} 
      id="title" placeholder="Add some additional information... (optional)" 
      value={description} onChange={e => setDescription(e.target.value)}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
            if (!waiting){
              submitJob()
            }
        }
        }} />
    </Flex>
    <Flex margin={["10px","20px"]} flexDir={["column","column","row"]}>
      <FormLabel width={["200px","100px"]}>Company Name</FormLabel>
      <Input
          borderColor={["#FBBF24"]}
          bgColor={"#63708e"}
          _hover={{borderColor : "#FEF3C7"}}
          _active={{borderColor : "#FEF3C7"}}
          _focus={{borderColor : "#FEF3C7"}}
          _placeholder={{ opacity: 0.5, color: 'white' }} width={["70vw","60vw"]}
          type={"text"} placeholder="Company Name"
          value={companyName} onChange={event => setCompanyName(event.target.value)}
          onKeyPress={(e) => {
        if (e.key === 'Enter') {
            if (!waiting){
              submitJob()
            }
        }
        }}
        >
      </Input>
    </Flex>
    <Center >

    <Box position={"relative"}>

    <Button 
    onClick={() =>{submitJob()}}
    backgroundColor="#63708e"
    borderRadius="0"
    color={"white"} position="relative"
    disabled={waiting}
    // right={0}
    // bottom={0}
    width={["250px"]}
    className={"bg-skills_blue-300"}
    >    {waiting ? (
                <Box >
                <Chatdots color='white'></Chatdots>
                </Box>
                ):("Generate")}
</Button>
</Box>
</Center>
{/* <Flex flexDir={"row-reverse"}>
<Button  
    onClick={() =>{submitJob()}}
    color={"black"} position="relative"
    right={0}
    bottom={0}
    variant={"solid"}>Generate
</Button>
    <>
    {waiting ? (
                    <Spinner
  thickness='4px'
  speed='0.65s'
  emptyColor='gray.200'
  color='blue.500'
  size='xl'
                marginRight={"10px"}
                />
                ):(null)}
                </>
    </Flex> */}

    </Flex>
  </Center>
      </Box>
      </Fade>

      </>
      ) : (
      <>
      
  <Box minH={"100vh"} >
  <Center color={"gray.800"}>
       { skillsStage ? (
        <Fade in={true} transition={{ enter: { duration: 0.35 } }}>
        <Flex marginTop={["10%","30px"]} maxW={"90vw"} flexDir={"column"}>
  {/* <List>
            {skills.map(({ key, value, selected }) => (
                <ListItem textAlign={"left"} color={"white"} key={key}>
                    <Checkbox isChecked={selected} onChange={() => handleCheck(key)}>{value}</Checkbox>
                </ListItem>
            ))}
  </List> */}
  <Text marginBottom={"20px"} fontSize={["20px","30px"]} color={"white"} >{title} Skills</Text>
  <Text marginBottom={"20px"} fontSize={["15px","20px"]} color={"white"} >Deselect Competencies that do not apply</Text>
  {/* <Grid templateColumns={["repeat(1, 1fr)","repeat(2, 1fr)"]} gap={1}>
            {skills.map(({ key, value, selected }) => (
                <Box key={key} textAlign="left" color="white">
                    <Checkbox isChecked={selected} onChange={() => handleCheck(key)}>{value}</Checkbox>
                </Box>
            ))}
        </Grid> */}
        <>
        <Box>
      {/* <Grid templateColumns={["repeat(1, 1fr)","repeat(1, 1fr)","repeat(2, 1fr)"]} gap={6}>
        <CompetencyList heading="Required Occupational Competencies" fieldKey={"required_occupational_competencies"} structuredSkills={structuredSkills.required_occupational_competencies} handleCheck={handleCheck}/>
        <CompetencyList heading="Required Foundational Competencies" fieldKey={"required_foundational_competencies"} structuredSkills={structuredSkills.required_foundational_competencies} handleCheck={handleCheck}/>
        <CompetencyList heading="Preferred Occupational Competencies" fieldKey={"preferred_occupational_competencies"}  structuredSkills={structuredSkills.preferred_occupational_competencies} handleCheck={handleCheck}/>
        <CompetencyList heading="Preferred Foundational Competencies" fieldKey={"preferred_foundational_competencies"}  structuredSkills={structuredSkills.preferred_foundational_competencies} handleCheck={handleCheck}/>
      </Grid> */}
      <Flex flexDir={"column"} marginBottom={"-70px"}>
        <CompetencyList handleAddSkillSpecific={handleAddSkillSpecific} heading="Occupational Competencies" fieldKey={"required_occupational_competencies"} structuredSkills={structuredSkills.required_occupational_competencies} handleCheck={handleCheck}/>
        <CompetencyList handleAddSkillSpecific={handleAddSkillSpecific} heading="Foundational Competencies" fieldKey={"required_foundational_competencies"} structuredSkills={structuredSkills.required_foundational_competencies} handleCheck={handleCheck}/>
        {/* <CompetencyList handleAddSkillSpecific={handleAddSkillSpecific} heading="Preferred Occupational Competencies" fieldKey={"preferred_occupational_competencies"}  structuredSkills={structuredSkills.preferred_occupational_competencies} handleCheck={handleCheck}/>
        <CompetencyList handleAddSkillSpecific={handleAddSkillSpecific} heading="Preferred Foundational Competencies" fieldKey={"preferred_foundational_competencies"}  structuredSkills={structuredSkills.preferred_foundational_competencies} handleCheck={handleCheck}/> */}
      </Flex>
    </Box>
    </>
        {/* <Button margin="20px" width={"200px"}  onClick={() =>{ 
          setShowInput(!showInput)}}
          >{!showInput ?("Add more skills!"):("Colapse Add Skills")}</Button>
        {showInput && (
          <FormControl marginLeft="20px">
            <FormLabel color={"white"} htmlFor="new-skill">{"New Skill"}</FormLabel>
            <Flex>
            <Input width={"50%"} color={"white"} type="text" id="new-skill"
                        onKeyPress={(e) => {
        if (e.key === 'Enter') {
         console.log("here")
         handleAddSkill()
        }
        }}
             value={newSkill} onChange={e => setNewSkill(e.target.value)} />
            <Flex flexDir={["column", "row", "row"]}>
            <Button paddingRight={"25px"} marginBottom={["5px","0px"]} paddingLeft={"25px"} marginLeft={["20px", "40px"]} onClick={handleAddSkill}>Add Skill To</Button>
            <Select bg={"white"} color="black" marginBottom={"10px"} marginLeft={"20px"} width={["120px","150px","160px"]} value={currentAddSelect.display} 
                onChange={
                (event) => {
                  console.log(event.target.value)
                setCurrentAddSelect(event.target.value)}
                }>
                    <option value="required_occupational_competencies">Req. OC</option>
                    <option value="preferred_occupational_competencies">Pref. OC</option>
                    <option value="required_foundational_competencies">Req. FC</option>
                    <option value="preferred_foundational_competencies">Pref. FC</option>
                </Select>
              </Flex>
            </Flex>
          </FormControl>
        )} */}
  <Button background={"#FBBF24"} disabled={waiting} margin={"20px"} onClick={() => {handleSelectedSkills() 
    setCurrentAddSelect("required_occupational_competencies")
    }} color={"black"}>{waiting ? (
    <Chatdots color=""></Chatdots>
):("Finish and Create!")}</Button>
  <Button margin={"20px"} onClick={() => {
  setDisplayGeneration(true) 
  setCurrentAddSelect("required_occupational_competencies")
  setShowInput(false)}} background={"#FBBF24"} color={"black"}> Back To Input</Button>

  </Flex>   
  </Fade>  
       ):(
<Fade in={true} transition={{ enter: { duration: 0.35 } }}>
  
  <Flex marginTop={["10%","20px"]} maxW={"90vw"} flexDir={"column"}>
  {/* <JobHolder title={title}  label={"Generated Job Post"} companyName={companyName} valueOfText={jobDescription}></JobHolder> */}
  
        <FinalEditBox handleCopy={handleCopy} handleSelectedSkills={handleSelectedSkills} title={title} setTitle={setTitle} submitJob={submitJob}  waiting={waiting} 
        setWaiting={setWaiting} description={description} setDescription={setDescription}
        companyName={companyName} setCompanyName={setCompanyName} companyUrl={companyUrl} 
        setCompanyUrl={setCompanyUrl}
        setDisplayGeneration={setDisplayGeneration} setShowInput={setShowInput}
        setSkillsStage={setSkillsStage}></FinalEditBox>
        <Box filter='auto' blur={waiting ? "5px" : 0} >
        <JobDescriptionPage experienceJobDescription={experienceJobDescription} formatedJobPost={formatedJobPost} descriptionObject= {descriptionObject} jobDescription={jobDescription}></JobDescriptionPage>
        </Box>
        <Center  >
        <Flex padding={"20px"} width={["80%","80%","70%","60%"]} background={"whiteAlpha.300"} flexDir={"column"}>
              <Flex flexDirection={"row"} justifyContent="center">
              <Button 
              _hover={{"background" : "whiteAlpha.500" }} width={"150px"} height={"150px"} background={thumbsUpBackColor}
               onClick={()=>{submitThumbs(true) 
              setThumbs(true)}} variant={"ghost"}>
              <Thumbsup width={"60px"} height={"60px"} fill={thumbsUpColor}></Thumbsup></Button>   
              <Button _hover={{"background" : "whiteAlpha.500" }}  width={"150px"} height={"150px"}  
              background={thumbsDownBackColor} 
              onClick={()=>{submitThumbs(false)
                setThumbs(false)}}  variant={"ghost"}>
              <Thumbsdown width={"60px"} height={"60px"} fill={thumbsDownColor}></Thumbsdown></Button> 

              </Flex>
            
              {thumbsFeedback ? (
                <>
                
                {submittedFeedback ? (<Text color={"white"} fontSize={"25px"} margin="25px">Thank you for your feedback!</Text>):(
                  <>

                  <Flex flexDir={"column"} alignItems="center">

                  <Input 
                  color={"white"}
                  marginTop={"30px"}
                  marginBottom={"30px"}
                  marginRight="10%"
                  marginLeft="10%"
                  borderColor={["#FBBF24"]}
                  bgColor={"#63708e"}
                  _hover={{borderColor : "#FEF3C7"}}
                  _active={{borderColor : "#FEF3C7"}}
                  _focus={{borderColor : "#FEF3C7"}}
                  _placeholder={{ opacity: 0.5, color: 'white' }} width={["70%","60%"]}
                  type={"text"} placeholder="What would have the ideal output looked like?"
                  value={feedback} onChange={event => setFeedback(event.target.value)}
                  onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                  console.log("submitting feedback")
                  feedbackSubmit()
                  }
                  }}>
                  </Input>
                  <Flex justifyContent={"right"}>
                  <Button color={"white"} variant={"ghost"} margin="20px">Cancel</Button> 
                  <Button onClick={feedbackSubmit} margin="20px">Submit Feedback</Button> 
                  </Flex>
                  </Flex>
                  </>
                )}
 
                </>
              ):(

                <>
                {submittedFeedback ? (null):(
                  <>

                <Text fontSize={"45px"} color="white">How did we do?</Text>
              <Text fontSize={"25px"} color="white">Was this job posting useful to you?</Text>
              </>)}

              </>
              )
            }
              </Flex>
        </Center>
        <Button margin={"20px"} onClick={() => {setSkillsStage(true)
          setCurrentAddSelect("required_occupational_competencies")
          setShowInput(false)}} color={"black"} background={"#FBBF24"}> Back to Skill Select! </Button>
          <Button margin={"20px"} onClick={() => {setDisplayGeneration(true)
            setCurrentAddSelect("required_occupational_competencies")
          setShowInput(false)}} color={"black"} background={"#FBBF24"}> Back To Input</Button>
        {/* <Textarea value={jobDescription} marginTop={"15px"} background={"whiteAlpha.400"} minW={"80vw"}>

        </Textarea> */}
        
    </Flex>
    </Fade>
       )
        }
  </Center>

      </Box>


      </>)}
      <Center marginTop={"20px"}>
            <a
              href="https://www.skillsengine.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
                        <Flex dir='row'>
              <Text marginTop={"5px"} paddingTop={"10px"} >By</Text>
              <Image
                src="/skills.png"
                alt="Skills Logo"
                width={"200px"}
              />
                        </Flex>
            </a>
        </Center>


    </>
  )
}
